"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flexParent = exports.flexParentCenterSpace = exports.flexParentCenter = void 0;

var _emotion = require("emotion");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  && {\n    display: flex;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  && {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  && {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var flexParentCenter = (0, _emotion.css)(_templateObject());
exports.flexParentCenter = flexParentCenter;
var flexParentCenterSpace = (0, _emotion.css)(_templateObject2());
exports.flexParentCenterSpace = flexParentCenterSpace;
var flexParent = (0, _emotion.css)(_templateObject3());
exports.flexParent = flexParent;